import Fachada from "../src/assets/images/fachada1.png";
import EmailLink from "./EmailLink";
import Icon from "../src/assets/images/favicon.ico";
import './App.css';




function App() {

    const entidade = "SEACOM - Sindicato dos Empregados de Agentes Autônomos de Comércio no Estado de Goiás";

    const recepcao = "recepcao@seacom.com.br";
    const secretaria = "secretaria@seacom.org.br";
    const secretaria2 = "secretaria@seacom.com.br";
    const atendimento = "atendimento@seacom.org.br";
    const atendimento2 = "atendimento@seacom.com.br";
    const homologacao = "homologacao2@seacom.org.br";
    const homologacao2 = "homologacao@seacom.com.br";
    const informatica = "informatica@seacom.org.br";
    const informatica2 = "informatica@seacom.com.br";

  return (
    <div className="title">
        <div className='titulo'>
            <h1 className='entidade'>{entidade}<p>CNPJ: 02.555.548/0001-23 | <i className="bi bi-geo-alt-fill"></i>Rua 76, nº 05, Setor Central - CEP: 74.045-130 - Goiânia-Goiás</p></h1>
            <h1 className='fone'><i className="bi bi-telephone-fill"></i>(62) 3225-7318 - 3087-9887</h1>                        
        </div>
        <div className='subtitulo'>
            <h1>SEACOM - Sempre em defesa dos trabalhadores de sua classe</h1>
        </div>
        <div className="site">
            <h1>
                - Se deseja acessar o site do SEACOM:
            </h1>
            
                <a href="https://seacom.org.br/" target="_blank" rel="noreferrer" 
                        style={{ 
                        textDecoration: 'none',
                        fontWeight: 600
                        }}>
                    <button className="button-site btn btn-outline-primary">
                        Acessar Site
                    </button>  
                </a>
        </div>
        <div className="emissaoguias">
            <h1>
                - Se deseja acessar a emissão de guias:
            </h1>
                <a href="https://www.seacom.com.br/emissaoguias/" target="_blank" rel="noreferrer" 
                        style={{ 
                            textDecoration: 'none',
                            fontWeight: 600
                            }}>
                    <button className="button-guias btn btn-outline-primary">
                        Acessar Emissão Guias
                    </button>
                </a> 
        </div>

        <div className="info">
            <img src={Fachada} alt="fachada" />
            <h2>
                O <b>{entidade}</b> representa o comércio que comercializa serviços.
                É o chamado terceiro setor. Ele foi instituído como entidade sindical no 
                dia 22 de setembro de 1978 e hoje representa cerca de 40 mil trabalhadores 
                no Estado de Goiás.
                Desde 1978 o <b>SEACOM</b> vem defendendo e protegendo os interesses profissionais
                das categorias por nós representadas, obtendo melhores condições de trabalho 
                através das negociações das convenções coletivas, acordos, dissídios, 
                além da defesa dos direitos jurídicos e demais interesses deste grupo representado.
            </h2>
        </div>
        <div className="departamentos">  
            <div className="departamento-titulo">
                <h1>DEPARTAMENTOS</h1>
            </div>
            <table className="table">
                <thead>
                    <tr>
                    <th className="departamento" scope="col">Departamento</th>
                    <th className="nome" scope="col">Nome</th>
                    <th className="e-mail" scope="col">E-mail</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="recepcao">Recepção</td>
                        <td className="recep">Matheus</td>
                        <td className="email">
                            <div style={{ marginBottom: "10px", marginTop: "5px" }}>
                                <i className="bi bi-envelope-at-fill" 
                                    style={{ color: "rgba(var(--bs-link-color-rgb)", marginRight: "4px"}}>
                                </i>
                                <EmailLink recepcao={recepcao}/>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td className="secretaria">Secretaria</td>
                        <td className="name">Letícia</td>
                        <td className="email" style={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                            <div style={{ marginBottom: "10px", marginTop: "5px" }}>
                                <i className="bi bi-envelope-at-fill" 
                                    style={{ color: "rgba(var(--bs-link-color-rgb)", marginRight: "4px"}}>
                                </i>
                                <EmailLink secretaria={secretaria}/>
                            </div>
                            <div style={{ marginBottom: "10px" }}>
                                <i className="bi bi-envelope-at-fill" 
                                    style={{ color: "rgba(var(--bs-link-color-rgb)", marginRight: "4px"}}>
                                </i>
                                <EmailLink secretaria2={secretaria2}/>
                            </div>
                            
                        </td>                        
                    </tr>
                    <tr>
                        <td className="atendimento">Emissão de guias / Cadastro</td>
                        <td className="name">Maria das Graças</td>
                        <td className="email" style={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                            <div style={{ marginBottom: "10px", marginTop: "5px" }}>
                                <i className="bi bi-envelope-at-fill" 
                                    style={{ color: "rgba(var(--bs-link-color-rgb)", marginRight: "4px"}}>
                                </i>
                                <EmailLink atendimento={atendimento}/>
                            </div>
                            <div style={{ marginBottom: "10px" }}>
                                <i className="bi bi-envelope-at-fill" 
                                    style={{ color: "rgba(var(--bs-link-color-rgb)", marginRight: "4px"}}>
                                </i>
                                <EmailLink atendimento2={atendimento2}/>
                            </div>
                        </td> 
                    </tr>
                    <tr>
                        <td className="homologacao">Homologação / Informação Trabalhista</td>
                        <td className="name">Edvaldo</td>
                        <td className="email" style={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                            <div style={{ marginBottom: "10px", marginTop: "5px" }}>
                                <i className="bi bi-envelope-at-fill" 
                                    style={{ color: "rgba(var(--bs-link-color-rgb)", marginRight: "4px"}}>
                                </i>
                                <EmailLink homologacao={homologacao}/>
                            </div>
                            <div style={{ marginBottom: "10px" }}>
                                <i className="bi bi-envelope-at-fill" 
                                    style={{ color: "rgba(var(--bs-link-color-rgb)", marginRight: "4px"}}>
                                </i>
                                <EmailLink homologacao2={homologacao2}/>
                            </div>
                        </td> 
                    </tr>
                    <tr>
                        <td className="informatica">TI</td>
                        <td className="name">Sérgio</td>
                        <td className="email" style={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                            <div style={{ marginBottom: "10px", marginTop: "5px" }}>
                                <i className="bi bi-envelope-at-fill" 
                                    style={{ color: "rgba(var(--bs-link-color-rgb)", marginRight: "4px"}}>
                                </i>
                                <EmailLink informatica={informatica}/>
                            </div>
                            <div style={{ marginBottom: "10px" }}>
                                <i className="bi bi-envelope-at-fill" 
                                    style={{ color: "rgba(var(--bs-link-color-rgb)", marginRight: "4px"}}>
                                </i>
                                <EmailLink informatica2={informatica2}/>
                            </div>
                        </td> 
                    </tr>
                </tbody>
            </table>
            <div className="horario-funcionamento">
                <h1>HORÁRIO DE FUNCIONAMENTO</h1>
            </div>
            <table className="table hrfuncionamento">
                <thead>
                    <tr>
                    <th className="segunda" scope="col">Segunda-feira</th>
                    <th className="terca" scope="col">Terça-feira</th>
                    <th className="quarta" scope="col">Quarta-feira</th>
                    <th className="quinta" scope="col">Quinta-feira</th>
                    <th className="sexta" scope="col">Sexta-feira</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="segunda-feira">10:00 às 16:00 hrs</td>
                        <td className="terca-feira">08:30 às 16:00 hrs</td>
                        <td className="quarta-feira">08:30 às 16:00 hrs</td>
                        <td className="quinta-feira">08:30 às 16:00 hrs</td>
                        <td className="sexta-feira">08:30 às 12:00 hrs</td>
                    </tr>
                    <tr>

                    </tr>
                </tbody>
            </table>
        </div>
        <section id="footer">
            <img className="logo" src={Icon} alt=""></img>
            <p>TrolTech Sistemas - Todos os direitos reservados</p>
       
        </section>
    </div>
  );
}

export default App;
